import { backendApi } from "../dynamicBAseQuery";

export const KeywordsApi = backendApi.injectEndpoints({
    overrideExisting: true,
    endpoints: (builder) => ({
        getAllCategoriesWithKeywords: builder.query({
            query: () => ({
                method: "GET",
                url: `getAllCategoriesWithKeywords`
            })
        }),
        
        // saveKeywords:builder.mutation({
        //     query:(args)=> ({
        //         method:'POST',
        //         url:'saveKeywords',
        //         body:{...args}
        //     })
        // }),

        // deleteKeywordsById:builder.mutation({
        //     query:(args)=> ({
        //         method:"POST",
        //         url:"deleteKeywordsById",
        //         body:{...args}
        //     })
        // }),

        // updateKeyword:builder.mutation({
        //     query:(args)=> ({
        //         method:"POST",
        //         url:"updateKeyword",
        //         body: {...args}
        //     })
        // }),

        getCategoriesKeywords:builder.query({
            query:()=>({
                method:"GET",
                url:`getCategoriesKeywords`
            })
        }),

        saveKeywords:builder.mutation({       
            query:(args)=> ({
                method:'POST',
                url:'saveKeywords',
                body:{...args}
            })
        }),

        deleteCategoryById:builder.mutation({    //delete categories...
            query:(args)=> ({
                method:'POST',
                url:'deleteCategoryById',
                body:{...args}
            })
        }),

        updateKeyword:builder.mutation({
            query:(args)=>({
                method:'POST',
                url:'updateKeyword',
                body:{...args}
            })
        }),

        saveCategoryName:builder.mutation({
            query:(args)=> ({
                method:'POST',
                url:'saveCategoryName',
                body:{...args}
            })
        }),

        deleteKeywordsById:builder.mutation({
            query:(args)=> ({
                method:'POST',
                url:'deleteKeywordsById',
                body:{...args}
            })
        }),
        
         keywordCategoryUpdate:builder.mutation({
            query:(args)=> ({
                method:'POST',
                url:'keywordCategoryUpdate',
                body:{...args}
            })
        }),
            
    })
})
export const {
    useGetAllCategoriesWithKeywordsQuery,

    useGetCategoriesKeywordsQuery,
    useSaveKeywordsMutation,
    useDeleteCategoryByIdMutation,
    useUpdateKeywordMutation,
    useSaveCategoryNameMutation,
    useDeleteKeywordsByIdMutation,
    useKeywordCategoryUpdateMutation,

}=KeywordsApi